import { EMPTY_STRING } from '../../../constants/common'

export const EpostStatusTimelineTrackingStatus = {
  Error: 7,
  InProduction: 3,
  Preparation: 1,
  Print: 4,
  Sent: 5,
  Shippable: 2,
}

export const EPOST_STATUS_TIMELINE_TRACKING_STATUS_TITLES = {
  [EpostStatusTimelineTrackingStatus.Error]:
    'EpostStatusTimeline.ErrorStatusTextKey',
  [EpostStatusTimelineTrackingStatus.InProduction]:
    'EpostStatusTimeline.InProductionStatusTextKey',
  [EpostStatusTimelineTrackingStatus.Preparation]:
    'EpostStatusTimeline.PreparationStatusTextKey',
  [EpostStatusTimelineTrackingStatus.Print]:
    'EpostStatusTimeline.PrintProcessStatusTextKey',
  [EpostStatusTimelineTrackingStatus.Sent]:
    'EpostStatusTimeline.SentStatusTextKey',
  [EpostStatusTimelineTrackingStatus.Shippable]:
    'EpostStatusTimeline.ShippableStatusTextKey',
}

export const EPOST_STATUS_TIMELINE_TRACKING_SUCCESS_STATUSES_ORDER = [
  EpostStatusTimelineTrackingStatus.Preparation,
  EpostStatusTimelineTrackingStatus.Shippable,
  EpostStatusTimelineTrackingStatus.InProduction,
  EpostStatusTimelineTrackingStatus.Print,
  EpostStatusTimelineTrackingStatus.Sent,
]

export const EPOST_STATUS_TIMELINE_TRACKING_ITEM = {
  code: null,
  completed: false,
  current: false,
  date: null,
  isError: false,
  isLast: false,
  isLastCompletedBeforeError: false,
  titleKey: EMPTY_STRING,
}
